<template>
  <div>
    <v-btn class="float-right" color="white" @click="showDialog"> <v-icon left>mdi-plus</v-icon> Create time slot </v-btn>
    <v-dialog v-model="showTimeSlotDialog" width="800" persistent v-if="showTimeSlotDialog">
      <v-card class="hoh-entry-form">
        <v-card-title class="headline primary white--text" primary-title
          >Create Time Slots:
          <v-chip class="ms-2 px-4 font-weight-bold primary--text" color="white" v-if="selectedLocation.location" style="border: 1px solid white">
            <v-icon color="primary" left v-if="showTimeSlotDialog">mdi-map-marker</v-icon>{{ selectedLocation.location }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn @click="closeModal()" left text fab small color="white"><v-icon>mdi-close</v-icon></v-btn></v-card-title
        >

        <v-card-text>
          <v-form style="margin: 0 auto" ref="slotForm">
            <v-row>
              <v-col md="12">
                <div class="my-1">
                  <label class="primary--text text-uppercase subtitle-1 font-weight-bold">Date</label>
                  <v-divider class="title-border"></v-divider>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col md="6">
                <!-- same day -->
                <div class="d-inline-block">
                  <v-switch v-model="formData.sameDay" label="Same Day" class="mt-0"> </v-switch>
                </div>
              </v-col>
            </v-row>

            <!-- start/end  date -->
            <v-row>
              <v-col md="6">
                <v-menu v-model="startDateMenuOpen" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedStartDate"
                      label="Start Date"
                      readonly
                      outlined
                      dense
                      class="required"
                      :rules="[(v) => !!v || 'This field is required']"
                      append-icon="mdi-calendar"
                      @click:append="startDateMenuOpen = true"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker :min="today" show-week @change="saveStartDate($event)" @input="startDateMenuOpen = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6">
                <v-menu v-model="endDateMenuOpen" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedEndDate"
                      label="End Date"
                      readonly
                      class="required"
                      outlined
                      dense
                      :disabled="formData.sameDay"
                      append-icon="mdi-calendar"
                      :rules="endDateRules"
                      @click:append="endDateMenuOpen = true"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker show-week @change="saveEndDate($event)" @input="endDateMenuOpen = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <div class="mt-0 mb-4">
              <label class="primary--text text-uppercase subtitle-1 font-weight-bold">Time Range Per Day</label>
              <v-divider class="title-border"></v-divider>
            </div>

            <!-- time first half -->
            <v-row class="mb-4">
              <v-col md="6">
                <div class="required custom-time-picker-wrapper" :class="vErrors.startTimeFirstHalfDay && 'error--text'">
                  <label>Start Time First Half of Day</label>
                  <vue-timepicker
                    v-if="showTimeSlotDialog"
                    manual-input
                    v-model="formData.startTimeFirstHalfDay"
                    close-on-complete
                    :minute-interval="minuteIntervalTimePicker"
                    format="hh:mm A"
                  ></vue-timepicker>
                  <div v-if="vErrors.startTimeFirstHalfDay" class="v-messages__message">{{ vErrors.startTimeFirstHalfDay }}</div>
                </div>
              </v-col>
              <v-col md="6">
                <div class="required custom-time-picker-wrapper" :class="vErrors.endTimeFirstHalfDay && 'error--text'">
                  <label>End Time First Half of Day</label>
                  <vue-timepicker
                    v-if="showTimeSlotDialog"
                    manual-input
                    v-model="formData.endTimeFirstHalfDay"
                    close-on-complete
                    :minute-interval="minuteIntervalTimePicker"
                    format="hh:mm A"
                  ></vue-timepicker>
                  <div v-if="vErrors.endTimeFirstHalfDay" class="v-messages__message">{{ vErrors.endTimeFirstHalfDay }}</div>
                </div>
              </v-col>
            </v-row>

            <div class="mt-0 mb-4">
              <label class="primary--text text-uppercase subtitle-1 font-weight-bold">Parameters</label>
              <v-divider class="title-border"></v-divider>
            </div>

            <!-- availability -->
            <v-row>
              <v-col md="6">
                <v-select
                  class="required"
                  :rules="[(v) => !!v || 'This field is required']"
                  :items="availabilityItems"
                  label="Availability"
                  outlined
                  dense
                  v-model="formData.availability"
                ></v-select>
              </v-col>
              <v-col md="6">
                <v-select
                  v-if="showTimeSlotDialog"
                  class="required"
                  :rules="[(v) => !!v || 'This field is required']"
                  :items="durationTimeSlots"
                  outlined
                  dense
                  label="Duration in Minutes"
                  v-model="formData.duration"
                ></v-select>
              </v-col>
            </v-row>

            <div class="my-4">
              <label class="primary--text text-uppercase subtitle-1 font-weight-bold">Test type</label>
              <v-divider class="title-border"></v-divider>
            </div>

            <!-- test type -->
            <TestTypesCheckboxSelection @testTypeSelected="testTypeSelectedParent" />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeModal()"> Cancel </v-btn>
          <v-btn color="success" :disabled="submittingForm" @click="submit()" class="mx-4">
            Submit
            <v-icon right>mdi-send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { TimeSlotFormFieldKeys } from '../models/time-slots-form-field-keys.js';
import TestTypesCheckboxSelection from '@/components/test-types/test-types-checkbox-selection.vue';

import VueTimepicker from 'vue2-timepicker';

import 'vue2-timepicker/dist/VueTimepicker.css';
// import { mapGetters } from 'vuex';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  components: { VueTimepicker, TestTypesCheckboxSelection },
  data() {
    return {
      formDataPrestine: JSON.stringify(new TimeSlotFormFieldKeys()),
      formData: new TimeSlotFormFieldKeys(),
      startDateMenuOpen: false,
      endDateMenuOpen: false,
      appointmentDateMenuOpen: false,
      appointmentDate: null,
      appointmentTime: null,
      sampleDateMenuOpen: false,
      birthDatePatientDialogOpen: false,
      required: false,
      submittingForm: false,
      endDateRules: [(v) => this.endDateRulesFn(v)],
      availabilityItems: [],
      durationTimeSlots: [5, 10, 15],
      minuteIntervalTimePicker: 5,
      vErrors: {
        startTimeFirstHalfDay: null,
        endTimeFirstHalfDay: null,
        startTimeSecondHalfDay: null,
        endTimeSecondHalfDay: null
      }
    };
  },
  watch: {
    sameDay(n) {
      if (n && this.formData.startDate) {
        this.formData.endDate = this.formData.startDate;
      }
    },
    showTimeSlotDialog(n) {
      // console.log(n, this.$refs.slotForm);
      if (this.$refs.slotForm && n === false) {
        console.log(n);
        this.$refs.slotForm.reset();
        this.formData = JSON.parse(this.formDataPrestine);
      }
    },
    clickedDate(n) {
      if (n) this.formData.startDate = n;
      else this.formData.startDate = null;
    }
  },
  computed: {
    computedStartDate() {
      return this.formData.startDate ? moment(this.formData.startDate, 'YYYY-MM-DD').format('D-MMMM-YYYY') : '';
    },
    computedEndDate() {
      return this.formData.endDate ? moment(this.formData.endDate, 'YYYY-MM-DD').format('D-MMMM-YYYY') : '';
    },
    selectedLocation() {
      return this.$store.state.appointmentsCalendarStore.locationSelected;
    },
    sameDay() {
      return this.formData.sameDay;
    },
    today() {
      return moment().format('YYYY-MM-DD');
    },
    showTimeSlotDialog() {
      return this.appointmentsCalendarStore.appointmentsCalendarPage.showTimeSlotDialog;
    },
    clickedDate() {
      return this.appointmentsCalendarStore.appointmentsCalendarPage.clickedDate;
    },
    ...mapState(['appointmentsCalendarStore']),
    ...mapGetters('doctorOptionsStore', ['getDoctorOptions']),
    ...mapActions('doctorOptionsStore', ['fetchDoctorOptions'])
  },
  created() {
    if (this.getDoctorOptions.length == 0) {
      this.fetchDoctorOptions; //this.$store.dispatch('doctorOptionsStore/fetchDoctorOptions');
    }

    for (let i = 0; i < 30; i++) {
      this.availabilityItems.push(i);
    }
  },
  methods: {
    saveTimeFromTimePickerComponent(data) {
      this.formData[data.key] = data.time;
    },
    submit() {
      //validation
      if (!this.$refs.slotForm.validate() || !this.customValidationValid()) return;

      let dataToPost = {
        duration: this.formData.duration,
        startDate: this.formatDateForSubmission(this.formData.startDate, this.formData.startTimeFirstHalfDay),
        endDate: this.formatDateForSubmission(this.formData.endDate, this.formData.endTimeFirstHalfDay),
        load: this.formData.availability,
        testCenter: this.selectedLocation,
        allowedTestTypes: this.formData.allowedTestTypes
      };

      this.submittingForm = true;
      this.$store.commit('SET_SHOW_LOADER', {
        action: true,
        text: 'One moment...'
      });

      this.$store.dispatch('appointmentsCalendarStore/submitAppointmentSlotsForm', dataToPost).then((data) => {
        this.submittingForm = false;
        this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
        if (data) {
          this.$emit('getCalendarEntriesParent');
          this.$store.commit('appointmentsCalendarStore/SET_TIME_SLOT_DIALOG', false);
          let payload = {
            open: true,
            text: 'Time slots added to calendar.',
            color: 'success'
          };
          this.$store.commit('SET_SNACKBAR', payload);
        }
      });
    },
    endDateRulesFn(endDate) {
      if (!endDate) return 'Field is required';
      else if (!this.formData.startDate) return true;

      const endDateFormatted = moment(endDate, 'DD-MMM-YYYY').format('YYYY-MM-DD');
      const startDateFormatted = moment(this.formData.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD');

      if (moment(endDateFormatted).isBefore(startDateFormatted, 'day')) return "End date can't be earlier than start date";
      else return true;
    },
    saveStartDate(value) {
      this.formData.startDate = value + 'T13:00:00.000Z[UTC]';
      if (this.formData.sameDay) this.formData.endDate = value + 'T13:00:00.000Z[UTC]';
    },
    saveEndDate(value) {
      this.formData.endDate = value + 'T13:00:00.000Z[UTC]';
    },
    showDialog() {
      //this.$store.commit('appointmentsCalendarStore/SET_CLICKED_DATE', moment());
      this.$store.commit('appointmentsCalendarStore/SET_TIME_SLOT_DIALOG', true);
    },
    cancelAppointmentDateTime() {
      this.appointmentDateMenuOpen = false;
      this.appointmentTime = null;
    },
    closeModal() {
      this.$store.commit('appointmentsCalendarStore/SET_TIME_SLOT_DIALOG', false);
      this.$store.commit('appointmentsCalendarStore/SET_CLICKED_DATE', null);
    },
    formattedTime(key) {
      if (this.formData[key]) return moment(this.formData[key], 'HH:mm').format('h:mm A');
      else return null;
    },
    customValidationValid() {
      let validator = [];
      let isValid = false;
      validator[0] = this.customValidatorTimePicker(this.formData.startTimeFirstHalfDay, 'startTimeFirstHalfDay', {
        required: true,
        validTime: true
      });
      validator[1] = this.customValidatorTimePicker(this.formData.endTimeFirstHalfDay, 'endTimeFirstHalfDay', {
        required: true,
        validTime: true,
        beforeThen: this.formData.startTimeFirstHalfDay
      });
      if (validator.includes(false)) isValid = false;
      else isValid = true;
      return isValid;
    },
    customValidatorTimePicker(value, key, rules) {
      if (rules.required && !value) {
        this.vErrors[key] = 'This field is required';
        return false;
      } else {
        this.vErrors[key] = null;
      }

      if (rules.beforeThen) {
        if (moment(value, 'hh:mm A').isBefore(moment(rules.beforeThen, 'hh:mm A')) || value == rules.beforeThen) {
          this.vErrors[key] = "Time can't be earlier or equal than the prior time input";
          return false;
        } else {
          this.vErrors[key] = null;
        }
      }

      if (rules.validTime) {
        if (!moment(value, 'hh:mm A', true).isValid()) {
          this.vErrors[key] = 'Is not a valid time input';
          return false;
        } else {
          this.vErrors[key] = null;
        }
      }

      return true;
    },
    formatDateForSubmission(date, time) {
      const dateFormatted = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
      const timeFormatted = moment(time, 'hh:mm A').format('HH:mm');
      return `${dateFormatted} ${timeFormatted}`;
    },
    testTypeSelectedParent(testTypes) {
      if (testTypes.length > 0) this.formData.allowedTestTypes = testTypes;
      else this.formData.allowedTestTypes = [];
    }
  }
};
</script>

<style lang="scss">
.custom-time-picker-wrapper {
  &.error--text {
    .vue__time-picker {
      input {
        border: 2px solid #b71c1c !important;
      }
    }
    .v-messages__message {
      font-size: 12px;
      line-height: 12px;
      margin: 3px 0 0 10px;
    }
  }
  .vue__time-picker {
    display: block;
    width: 100%;
    input {
      width: 100% !important;
      height: 40px !important;
      padding: 8px !important;
      border: none !important;
      border: 1px solid rgb(118, 118, 118) !important;
      font-size: 16px !important;
      border-radius: 3px;
    }
    .dropdown {
      width: 100%;
      .select-list {
        width: 100%;
      }
      ul li:not([disabled]).active,
      ul li:not([disabled]).active:hover {
        background: #36a0dd;
      }
    }
  }
}
</style>
